import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';
import { CookieCompliance, CookieComplianceCategories } from '@deporvillage/utils-library-component';
import { CartContext } from '../../../context/cart/context';


const FacebookID = '805508019477694';

const PageType = {
    Product: 'product',
};

const trackInit = (id) => window.fbq && window.fbq('init', id);
const trackView = () => window.fbq && window.fbq('track', 'PageView');

const trackProductPage = ({ sku, price }, currency) =>
    window.fbq && window.fbq('track', 'ViewContent', {
        contents: [{ id: sku, quantity: 1 }],
        content_type: 'product',
        value: price.toFixed(2),
        currency,
    });

const trackCart = (model, amount, currency) =>
    window.fbq && window.fbq('track', 'AddToCart', {
        contents: model,
        content_type: 'product',
        value: +amount,
        currency,
    });

const mapCartItem = ({ quantity, sku }) => ({
    id: sku,
    quantity,
});

const FacebookPixel = ({ page, currency, product }) => {
    const mounted = React.useRef(false);
    const [cartData] = React.useContext(CartContext);
    const [isInit, setInit] = React.useState(false);

    const handleInit = (canRunAds) => mounted.current && setInit(canRunAds);

    React.useEffect(() => {
        if (!isInit) return;
        trackInit(FacebookID);
        trackView();
        if (page === PageType.Product) trackProductPage(product, currency);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInit]);

    React.useEffect(() => {
        if (isInit && cartData?.isOpened) {
            const model = cartData.items.map(mapCartItem);
            trackCart(model, cartData.amount, currency);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartData, isInit]);

    React.useEffect(() => {
        mounted.current = true;
        CookieCompliance(handleInit, CookieComplianceCategories.Targeting);
        return () => { mounted.current = false; };
    }, []);

    return isInit && (
        <Script id={'frontend-common-facebook-pixel'} strategy={'afterInteractive'}>
            {
                `!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');`
            }
        </Script>
    );
};

FacebookPixel.propTypes = {
    product: PropTypes.shape({
        price: PropTypes.number,
        sku: PropTypes.string,
    }),
    page: PropTypes.string,
    currency: PropTypes.string,
};

export default FacebookPixel;
